<template>
  <div class="max-w-7xl mx-auto w-full">
    <div class="p-5">
      <h2
        class="text-black text-[24px] font-bold md:text-center text-left md:block hidden"
      >
        Related Blogs
      </h2>
      <h2
        class="text-black text-[24px] font-bold md:text-center text-left md:hidden block"
      >
        Related Article
      </h2>
      <div class="carousel relative mx-auto py-5">
        <div class="slick_related relative" v-if="this.feature">
          <div class="" v-for="blog in feature.slice(0, 4)" :key="blog.id">
            <a :href="`/blogs/${blog.slug}`">
              <div
                class="relative rounded-xl flex flex-col gap-2 text-start bg-white p-5 md:!w-[100%] mx-auto h-[150px] drop-shadow-lg"
              >
                <h2 class="text-[#1F1F1F] md:text-lg text-sm font-bold">
                  {{ blog.title }}
                </h2>
                <p class="text-[14px] text-[#454545] flex gap-3 items-center">
                  {{ formatDate(blog.publish_at) }}
                  <span class="h-[6px] w-[6px] rounded-full bg-black"></span>
                  {{ blog.category.title }}
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- mobile -->
    <div class="md:hidden block">
      <div
        class="flex md:flex-col lg:flex-row flex-wrap gap-3 justify-between p-5"
        v-if="this.popularBlogs"
      >
        <div v-for="blog in popularBlogs.slice(0, 2)" :key="blog.id" class="">
          <a :href="`/blogs/${blog.slug}`">
            <div class="flex gap-4">
              <div class="w-[40%]">
                <img
                  :src="blog.image"
                  alt=""
                  class="h-full object-cover rounded-lg"
                />
              </div>
              <div class="w-[60%] text-justify flex flex-col gap-2">
                <h2 class="text-[#1F1F1F] flex-wrap text-sm font-bold">
                  {{ blog.title }}
                </h2>
                <p class="flex-wrap hidden md:block">
                  {{ blog.description }}
                </p>
                <p class="text-[14px] flex gap-3 items-center">
                  {{ formatDate(blog.publish_at) }}
                  <span class="h-[6px] w-[6px] rounded-full bg-black"></span>
                  {{ blog.category.title }}
                </p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <!-- mobile -->
  </div>
</template>

<script>
import $ from "jquery";
import "slick-carousel";
import axios from "axios";
export default {
  name: "RelatedBlogs",
  data() {
    return {
      feature: [],
      popularBlogs: [],
    };
  },
  mounted() {
    this.fetchFeaturedBlogs();
    this.fetchMostPopularBlogs();
  },
  methods: {
    fetchFeaturedBlogs() {
      axios
        .get(`${process.env.VUE_APP_API}/blog/blog-list/?future_article=true`)
        .then((response) => {
          this.feature = response.data.data;

          setTimeout(() => {
            $(".slick_related").slick({
              infinite: true,
              autoplay: true,
              prevArrow: false,
              nextArrow: false,
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: true,
              dotsClass: "slick-dots",

              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 950,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 650,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 420,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  },
                },
              ],
            });
          }, 0);
          console.log(this.feature, "hello");
        })
        .catch((error) => {
          console.error("Error fetching feature blogs:", error);
        });
    },
    fetchMostPopularBlogs() {
      const apiUrl = `${process.env.VUE_APP_API}/blog/blog-list/?most_popular=true`;
      axios
        .get(apiUrl)
        .then((response) => {
          this.popularBlogs = response.data.data;
          // this.initSlider();
        })
        .catch((error) => {
          console.error("Error fetching most popular blogs:", error);
        });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const options = { month: "long", day: "2-digit", year: "numeric" };
      return date.toLocaleDateString("en-US", options);
    },
  },
};
</script>

<style scoped></style>
